import { Component, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CalService } from './core/services/cal.service';
import { CommonService } from './core/services/common.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from './shared/shared.module';
import { RouterModule } from '@angular/router';
import { Loader } from './core/components/loader/loader';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterModule, SharedModule, Loader],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('gus-nma-fsm-ui-app');


  private calService = inject(CalService);
  welcomeName!: string;

  constructor(public commonService: CommonService,
    private router: Router,

  ) {
    this.calService.getFirstName().subscribe((name: any) => {
      this.welcomeName = name;
    });
  }

  ngOnInit() {
    // Initialize authentication on startup
    this.initializeAuthentication();
  }
  isLogin: boolean = false;
  private async initializeAuthentication() {
    try {
      this.commonService.isAuthenticatingSignal.set(true);
      // Sign in user
      const user = await this.calService.signIn();
      // Get token and store it
      const token = await this.calService.getAADToken();

      if (token) {
        // Store token in session storage
        window.sessionStorage.setItem('AuthToken', token as string);
        this.commonService.isAuthenticatingSignal.set(true);

        this.isLogin = true;

        let roles = this.calService.getUserRoles();

        const fullUrl = this.router.url;

        if (localStorage.getItem('firstAuthToken') === '1') {
          if (fullUrl === '/' || fullUrl === '') {
            if (roles.includes('NMAFSM.Admin') || roles.includes('NMAFSM.ReportsAndData')) {
              this.router.navigate(['/foundation/home']);
            } else if (roles.includes('NMAFSM.DataEntry')) {
              this.router.navigate(['/foundation/elevation']);
            } else if (roles.includes('NMAFSM.ReportViewer')) {
              this.router.navigate(['/reporting']);
            }
          }
          localStorage.setItem('firstAuthToken', '0');
        }
      } else {
        console.warn("No authentication token received");
        this.commonService.isAuthenticatingSignal.set(true);
      }



    } catch (error) {
      console.error("Authentication failed:", error);
      this.commonService.isAuthenticatingSignal.set(false);
    } finally {
      // this.isAuthenticating = false;
    }
  }

}
